import React, { useState, useMemo, useEffect } from "react";
import { IoIosArrowDropdown } from "react-icons/io";
import "./sevenA.css";
import { RiResetLeftLine } from "react-icons/ri";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { getCurrentFY, getFinancialYearMonthsPassed } from "../../Utilitie";
const monthsRef = [
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
  "Jan",
  "Feb",
  "Mar",
];
const SAController = ({
  data,
  setFilteredSevenA,
  openStates,
  setOpenStates,
  setStatus,
}) => {
  // State for search inputs (one per dropdown)\
  const [searchValues, setSearchValues] = useState({
    Year: "",
    "Group Commodity": "",
    "Sub Group Commodity": "",
    Commodity: "",
    Month: "",
    "From Station": "",
    "To Station": "",
  });
  const [selectedFY, setSelectedFY] = useState(new Set());
  const [selectedGroupComm, setSelectedGroupComm] = useState(new Set());
  const [selectedSubGroupComm, setSelectedSubGroupComm] = useState(new Set());
  const [selectedComm, setSelectedComm] = useState(new Set());
  const [selectedMonths, setSelectedMonths] = useState(new Set());
  const [selectedFromStns, setSelectedFromStns] = useState(new Set());
  const [selectedToStns, setSelectedToStns] = useState(new Set());
  useEffect(() => {
    setStatus({
      Commodity: [...selectedGroupComm],
      months: [...selectedMonths],
      years: [...selectedFY],
    });
  }, [selectedGroupComm, selectedMonths, selectedFY]);

  const toggleSelection = (setFunc, currentSet, value) => {
    const newSet = new Set(currentSet);
    newSet.has(value) ? newSet.delete(value) : newSet.add(value);
    setFunc(newSet);
  };

  const toggleDropdown = (title) => {
    setOpenStates((prev) => ({
      ...prev,
      [title]: !prev[title],
    }));
  };

  const handleSearchChange = (title, value) => {
    setSearchValues((prev) => ({
      ...prev,
      [title]: value,
    }));
  };

  const filteredData = useMemo(() => {
    if (!data?.data7A) return [];
    return data.data7A
      .filter((entry) => selectedFY.has(entry.F_YEAR))
      .map((entry) => {
        const filteredCommodities = (entry.commodities_data || [])
          .filter((group) => selectedGroupComm.has(group.GROUP_COMMODITY))
          .map((group) => {
            const filteredGroupCommodities = (
              group.group_commodities_data || []
            )
              .filter((subGroup) =>
                selectedSubGroupComm.has(subGroup.SUB_GROUP_COMMODITY)
              )
              .map((subGroup) => {
                const filteredSubCommodities = (
                  subGroup.sub_commodities_data || []
                )
                  .filter((comm) => selectedComm.has(comm.COMMODITY))
                  .map((comm) => {
                    const filteredMonths = (comm.months_data || [])
                      .filter((month) => selectedMonths.has(month.A_MONTH))
                      .map((month) => {
                        const filteredInnerData = (month.data || []).filter(
                          (d) =>
                            selectedFromStns.has(d.FROM_STN) &&
                            (selectedToStns.size === 0 ||
                              selectedToStns.has(d.TO_STN))
                        );
                        return { ...month, data: filteredInnerData };
                      })
                      .filter((month) => month.data.length > 0);
                    return { ...comm, months_data: filteredMonths };
                  })
                  .filter((comm) => comm.months_data.length > 0);
                return {
                  ...subGroup,
                  sub_commodities_data: filteredSubCommodities,
                };
              })
              .filter((subGroup) => subGroup.sub_commodities_data.length > 0);
            return {
              ...group,
              group_commodities_data: filteredGroupCommodities,
            };
          })
          .filter((group) => group.group_commodities_data.length > 0);
        return { ...entry, commodities_data: filteredCommodities };
      })
      .filter((entry) => entry.commodities_data.length > 0);
  }, [
    data,
    selectedFY,
    selectedGroupComm,
    selectedSubGroupComm,
    selectedComm,
    selectedMonths,
    selectedFromStns,
    selectedToStns,
  ]);
  const availableFY = useMemo(() => {
    return [...new Set((data?.data7A || []).map((d) => d.F_YEAR))];
  }, [data]);

  const availableGroupComm = useMemo(() => {
    return [
      ...new Set(
        (data?.data7A || [])
          .filter((entry) => selectedFY.has(entry.F_YEAR))
          .flatMap((entry) => entry.commodities_data || [])
          .map((group) => group.GROUP_COMMODITY)
      ),
    ];
  }, [data, selectedFY]);

  const availableSubGroupComm = useMemo(() => {
    return [
      ...new Set(
        (data?.data7A || [])
          .filter((entry) => selectedFY.has(entry.F_YEAR))
          .flatMap((entry) => entry.commodities_data || [])
          .filter((group) => selectedGroupComm.has(group.GROUP_COMMODITY))
          .flatMap((group) => group.group_commodities_data || [])
          .map((subGroup) => subGroup.SUB_GROUP_COMMODITY)
      ),
    ];
  }, [data, selectedFY, selectedGroupComm]);

  const readilyAvailableComm = useMemo(() => {
    return [
      ...new Set(
        (data?.data7A || [])
          .filter((entry) => selectedFY.has(entry.F_YEAR))
          .flatMap((entry) => entry.commodities_data || [])
          .filter((group) => selectedGroupComm.has(group.GROUP_COMMODITY))
          .flatMap((group) => group.group_commodities_data || [])
          .filter((subGroup) =>
            selectedSubGroupComm.has(subGroup.SUB_GROUP_COMMODITY)
          )
          .flatMap((subGroup) => subGroup.sub_commodities_data || [])
          .map((comm) => comm.COMMODITY)
      ),
    ];
  }, [data, selectedFY, selectedGroupComm, selectedSubGroupComm]);

  const availableMonths = useMemo(() => {
    return [
      ...new Set(
        (data?.data7A || [])
          .filter((entry) => selectedFY.has(entry.F_YEAR))
          .flatMap((entry) => entry.commodities_data || [])
          .filter((group) => selectedGroupComm.has(group.GROUP_COMMODITY))
          .flatMap((group) => group.group_commodities_data || [])
          .filter((subGroup) =>
            selectedSubGroupComm.has(subGroup.SUB_GROUP_COMMODITY)
          )
          .flatMap((subGroup) => subGroup.sub_commodities_data || [])
          .filter((comm) => selectedComm.has(comm.COMMODITY))
          .flatMap((comm) => comm.months_data || [])
          .map((m) => m.A_MONTH)
      ),
    ];
  }, [data, selectedFY, selectedGroupComm, selectedSubGroupComm, selectedComm]);
  availableMonths.sort((a, b) => monthsRef.indexOf(a) - monthsRef.indexOf(b));
  const availableFromStn = useMemo(() => {
    return [
      ...new Set(
        (data?.data7A || [])
          .filter((entry) => selectedFY.has(entry.F_YEAR))
          .flatMap((entry) => entry.commodities_data || [])
          .filter((group) => selectedGroupComm.has(group.GROUP_COMMODITY))
          .flatMap((group) => group.group_commodities_data || [])
          .filter((subGroup) =>
            selectedSubGroupComm.has(subGroup.SUB_GROUP_COMMODITY)
          )
          .flatMap((subGroup) => subGroup.sub_commodities_data || [])
          .filter((comm) => selectedComm.has(comm.COMMODITY))
          .flatMap((comm) => comm.months_data || [])
          .filter((month) => selectedMonths.has(month.A_MONTH))
          .flatMap((month) => month.data || [])
          .map((d) => d.FROM_STN)
      ),
    ];
  }, [
    data,
    selectedFY,
    selectedGroupComm,
    selectedSubGroupComm,
    selectedComm,
    selectedMonths,
  ]);

  const availableToStn = useMemo(() => {
    return [
      ...new Set(
        (data?.data7A || [])
          .filter((entry) => selectedFY.has(entry.F_YEAR))
          .flatMap((entry) => entry.commodities_data || [])
          .filter((group) => selectedGroupComm.has(group.GROUP_COMMODITY))
          .flatMap((group) => group.group_commodities_data || [])
          .filter((subGroup) =>
            selectedSubGroupComm.has(subGroup.SUB_GROUP_COMMODITY)
          )
          .flatMap((subGroup) => subGroup.sub_commodities_data || [])
          .filter((comm) => selectedComm.has(comm.COMMODITY))
          .flatMap((comm) => comm.months_data || [])
          .filter((month) => selectedMonths.has(month.A_MONTH))
          .flatMap((month) =>
            (month.data || [])
              .filter((d) => selectedFromStns.has(d.FROM_STN))
              .map((d) => d.TO_STN)
          )
      ),
    ];
  }, [
    data,
    selectedFY,
    selectedGroupComm,
    selectedSubGroupComm,
    selectedComm,
    selectedMonths,
    selectedFromStns,
  ]);

  const defaultSetup = () => {
    if (!data?.data7A?.length) return;

    const allFY = new Set(data.data7A.map((d) => d.F_YEAR));
    const allGroupComm = new Set(
      data.data7A
        .flatMap((d) => d.commodities_data || [])
        .map((group) => group.GROUP_COMMODITY)
    );
    const allSubGroupComm = new Set(
      data.data7A
        .flatMap((d) => d.commodities_data || [])
        .flatMap((group) => group.group_commodities_data || [])
        .map((subGroup) => subGroup.SUB_GROUP_COMMODITY)
    );
    const allComm = new Set(
      data.data7A
        .flatMap((d) => d.commodities_data || [])
        .flatMap((group) => group.group_commodities_data || [])
        .flatMap((subGroup) => subGroup.sub_commodities_data || [])
        .map((comm) => comm.COMMODITY)
    );
    const allMonths = new Set(
      data.data7A
        .flatMap((d) => d.commodities_data || [])
        .flatMap((group) => group.group_commodities_data || [])
        .flatMap((subGroup) => subGroup.sub_commodities_data || [])
        .flatMap((comm) => comm.months_data || [])
        .map((m) => m.A_MONTH)
    );
    const allFromStns = new Set(
      data.data7A
        .flatMap((d) => d.commodities_data || [])
        .flatMap((group) => group.group_commodities_data || [])
        .flatMap((subGroup) => subGroup.sub_commodities_data || [])
        .flatMap((comm) => comm.months_data || [])
        .flatMap((m) => m.data || [])
        .map((d) => d.FROM_STN)
    );
    const allToStns = new Set(
      data.data7A
        .flatMap((d) => d.commodities_data || [])
        .flatMap((group) => group.group_commodities_data || [])
        .flatMap((subGroup) => subGroup.sub_commodities_data || [])
        .flatMap((comm) => comm.months_data || [])
        .flatMap((m) => m.data || [])
        .map((d) => d.TO_STN)
    );

    const monthsPassed = getFinancialYearMonthsPassed(getCurrentFY(), false);

    setSelectedFY(allFY);
    setSelectedGroupComm(allGroupComm);
    setSelectedSubGroupComm(allSubGroupComm);
    setSelectedComm(allComm);
    setSelectedMonths(monthsPassed);
    setSelectedFromStns(allFromStns);
    setSelectedToStns(allToStns);
    setOpenStates({
      Year: false,
      "Group Commodity": false,
      "Sub Group Commodity": false,
      Commodity: false,
      Month: false,
      "From Station": false,
      "To Station": false,
    });
  };
  useEffect(() => {
    defaultSetup();
  }, [data]);
  const renderCheckboxList = (title, items, selectedSet, setFunc) => {
    // Filter items based on search value
    const filteredItems = items.filter((item) =>
      item.toString().toLowerCase().includes(searchValues[title].toLowerCase())
    );

    return (
      <div
        className={`${
          title === "Sub Group Commodity" ? "col-md" : "col-md"
        }  mt-2 p-1 `}
      >
        <div
          className="bg-light"
          style={{
            position: "relative",
            fontSize: 12,

            borderRadius: "5px",
          }}
        >
          <div
            className="papaDiv"
            onClick={() => toggleDropdown(title)}
            style={{
              border: "1px solid #ccc",
              padding: "8px",
              cursor: "pointer",
              minWidth: "150px",
              maxHeight: "50px",
              overflow: "hidden",
              userSelect: "none",
            }}
          >
            Select {title}  
            <IoIosArrowDropdown
              style={{
                fontSize: 15,
                transition: "transform 0.3s ease",
                transform: openStates[title]
                  ? "rotate(180deg)"
                  : "rotate(0deg)",
              }}
            />
          </div>
          {openStates[title] && (
            <div
              className="papaDiv"
              style={{
                position: "absolute",
                top: "100%",
                left: 0,
                right: 0,
                border: "1px solid #ccc",
                background: "#fff",
                zIndex: 10,
              }}
            >
              <strong>{title}</strong>
              <input
                style={{ height: "25px", width: "90%" }}
                className="form-control ms-2 mb-1 me-2"
                type="search"
                placeholder={`Search ${title}...`}
                aria-label={`Search ${title}`}
                value={searchValues[title]}
                onChange={(e) => handleSearchChange(title, e.target.value)}
              />
              <hr className="m-0  p-0" />
              <div
                className="row suggestion mt-1"
                key={filteredItems.length}
                style={{
                  maxHeight: "250px",
                  minHeight: "50px",
                  overflowY: "auto",
                }}
              >
                {filteredItems.length > 0 ? (
                  filteredItems.map((item, index) => (
                    <div
                      key={index}
                      className="col-md-4 fade-in"
                      style={{ fontSize: "12px" }}
                    >
                      <label
                        className="ms-1 text-start"
                        key={item}
                        style={{ display: "block", cursor: "pointer" }}
                      >
                        <input
                          className="form-check-input"
                          type="checkbox"
                          checked={selectedSet.has(item)}
                          onChange={() =>
                            toggleSelection(setFunc, selectedSet, item)
                          }
                        />
                        {item}
                      </label>
                    </div>
                  ))
                ) : (
                  <div className="col-md-12 text-center">No items found</div>
                )}
              </div>
              <hr className="m-0 p-0" />
              <div className="d-flex justify-content-evenly mt-1 ">
                <button
                  className="btn btn-sm btn-outline-primary"
                  onClick={() => setFunc(new Set(items))}
                >
                  Select All
                </button>
                <button
                  className="btn btn-sm btn-outline-success"
                  onClick={() => setFunc(new Set())}
                >
                  Clear All
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    );
  };
  useEffect(() => {
    setFilteredSevenA(filteredData);
  }, [filteredData]);
  return (
    <div className="m-3">
      <div
        className="row"
        style={{
          border: "1px solid  #ccc ",
          background: "rgba(255, 255, 255, 0.22)", // less opaque for more blur effect
          boxShadow: "5px 5px 20px rgba(7, 7, 7, 0.3)",
          backdropFilter: "blur(15px)", // applies the blur
          WebkitBackdropFilter: "blur(10px)", // for Safari support
        }}
      >
        {renderCheckboxList("Year", availableFY, selectedFY, setSelectedFY)}
        {renderCheckboxList(
          "Group Commodity",
          availableGroupComm,
          selectedGroupComm,
          setSelectedGroupComm
        )}
        {renderCheckboxList(
          "Sub Group Commodity",
          availableSubGroupComm,
          selectedSubGroupComm,
          setSelectedSubGroupComm
        )}
        {renderCheckboxList(
          "Commodity",
          readilyAvailableComm,
          selectedComm,
          setSelectedComm
        )}
        {renderCheckboxList(
          "Month",
          availableMonths,
          selectedMonths,
          setSelectedMonths
        )}
        {renderCheckboxList(
          "From Station",
          availableFromStn,
          selectedFromStns,
          setSelectedFromStns
        )}
        {renderCheckboxList(
          "To Station",
          availableToStn,
          selectedToStns,
          setSelectedToStns
        )}

        <OverlayTrigger
          delay={{ show: 100, hide: 200 }}
          overlay={<Tooltip id={`tooltip-1`}>Reset Filter</Tooltip>}
        >
          <div
            className="btn btn-sm btn-danger d-flex justify-content-center align-items-center mt-1 mb-1 "
            style={{
              maxWidth: "35px",
              boxShadow: " 3px 3px 10px rgba(52, 80, 142, 0.5) ",
            }}
            onClick={() => {
              defaultSetup();
            }}
          >
            <RiResetLeftLine style={{ fontSize: "15px", fontWeight: "bold" }} />
          </div>
        </OverlayTrigger>
      </div>
    </div>
  );
};

export default SAController;
